<template>
  <div class="home">
    <Profile />
    <!--    <Feedback />-->
  </div>
</template>

<script>
import Profile from "@/components/Profile.vue";
// import Feedback from '@/components/Feedback.vue'
export default {
  name: "Home",
  components: {
    Profile,
    // Feedback
  },
  mounted() {
    setTimeout(function () {
      let height = document.body.scrollHeight;
      parent.postMessage({ height: height }, "*");
    }, 300);
  }
};
</script>
